// extracted by mini-css-extract-plugin
export default {"container":"session-expired_container__f9855","title":"session-expired_title__52b72"};